import Tooltip from '@mui/material/Tooltip'
import { MdError } from 'react-icons/md'
import { CiCircleInfo } from 'react-icons/ci'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { LuSettings2 } from 'react-icons/lu'
import { useMediaQuery } from 'react-responsive'
import { LuListTodo } from 'react-icons/lu'
import { BsHourglassSplit } from 'react-icons/bs'
import useHeader from '../../../../hooks/useHeader'
import { BiSelectMultiple } from 'react-icons/bi'
import { useTourContext } from '../../../../context/TourContext'
import { useAuthContext } from '../../../../context'
import { useCallback } from 'react'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { settings } from 'settings'

const Header = ({
  hasHint,
  isCreateSubject,
  showSkeleton,
  handleGridsSidebar,
  isLoading,
  currentGrila,
  setOpen,
  setOpenInfoModal,
  handleGetRemainingTimeString,
  handleOpenHintModal,
  started,
  endTrial,
  setFilterSettings,
  isSubject,
  createGrid,
  hint,
  isMultipleChoice,
  handleSaveGrid,
  handleRemoveSavedGrid,
  isGridSaved,
  allowHint,
  handleOpenNoteModal,
  isSubmitted,
  isSubmittingGrid,
  isSubmittingSubject,
}) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 1280px)',
  })

  const isSubmitting = isSubject ? isSubmittingSubject : isSubmittingGrid

  const showHintButton = createGrid ? hint : true
  const { handleNextTourStep, handleUnFocusTour, handleFocusTour } =
    useTourContext()
  const { userDetails } = useAuthContext()
  const { timerVisible, handleVisibility } = useHeader()
  const handleClickOnTime = useCallback(() => {
    if (!userDetails?.tutorial) {
      handleUnFocusTour()
      handleNextTourStep()
    } else {
      handleVisibility()
    }
  }, [
    handleNextTourStep,
    handleUnFocusTour,
    handleVisibility,
    userDetails?.tutorial,
  ])

  return (
    <div className="w-full rounded-tr h-12 bg-secondary-container-background rounded-tl flex items-center top-0 z-[100] justify-between p-[5px] border-b border-brd-primary">
      {isLoading || (showSkeleton && !currentGrila) ? (
        <div className="flex gap-1 ">
          {isLoading ? (
            <div className="bg-[#868484] rounded-full w-[25px] h-[25px]"></div>
          ) : null}
          <div className="bg-[#868484] rounded-full w-[25px] h-[25px]"></div>
        </div>
      ) : (
        <div className="flex text-over-secondary-background justify-start gap-1 w-16 items-center">
          {!createGrid && currentGrila ? (
            <Tooltip className="report-grid" title="Raportează o problemă">
              <div>
                <MdError
                  onClick={() => {
                    setOpen(o => !o)
                    if (!userDetails?.tutorial) {
                      handleUnFocusTour()
                      handleNextTourStep()
                    }
                  }}
                  className="w-[30px] cursor-pointer h-[30px] text-error"
                />
              </div>
            </Tooltip>
          ) : null}
          {!createGrid && currentGrila ? (
            <Tooltip className="grid-info" title="Detalii grilă">
              <div>
                <CiCircleInfo
                  onClick={() => {
                    setOpenInfoModal(true)
                    if (!userDetails?.tutorial) {
                      // eslint-disable-next-line no-constant-condition
                      if (false && settings.pages_enabled) {
                        handleFocusTour()
                        setTimeout(handleNextTourStep, 300)
                      } else {
                        handleUnFocusTour()
                      }
                    }
                  }}
                  className="w-[30px] cursor-pointer h-[30px]"
                />
              </div>
            </Tooltip>
          ) : null}
        </div>
      )}

      <div className="flex gap-[15svh] font-bold text-[#545454]">
        {isLoading || (showSkeleton && !currentGrila) ? (
          <>
            <div className="h-[20px] bg-[#868484] w-[100px] rounded"></div>
          </>
        ) : !isCreateSubject && !createGrid ? (
          <>
            <button type="button" onClick={handleClickOnTime}>
              {timerVisible === 'on' ? (
                <Tooltip title="Ascunde">
                  <div className="text-over-secondary-background text-[16px] xlg:text-[20px] grid-timer">
                    {handleGetRemainingTimeString !== undefined &&
                      handleGetRemainingTimeString()}
                  </div>
                </Tooltip>
              ) : (
                <Tooltip title="Arată">
                  <div>
                    <BsHourglassSplit className="text-over-secondary-background" />
                  </div>
                </Tooltip>
              )}
            </button>
          </>
        ) : null}
      </div>
      <div className="flex items-center gap-[5px] w-16 justify-end mt-[3px]">
        {isLoading || (showSkeleton && !currentGrila) ? (
          <>
            <div className="bg-[#868484] rounded-full w-[25px] h-[25px]"></div>
            <div className="bg-[#868484] rounded-full w-[25px] h-[25px]"></div>
          </>
        ) : (
          <>
            {showHintButton &&
            currentGrila &&
            allowHint &&
            hasHint &&
            !createGrid &&
            !isCreateSubject ? (
              <Tooltip title="Indiciu">
                <FontAwesomeIcon
                  onClick={handleOpenHintModal}
                  className="text-secondary hint-modal cursor-pointer w-[25px] h-[25px]"
                  icon={faLightbulb}
                />
              </Tooltip>
            ) : null}
            {/* {!createGrid && currentGrila && isMultipleChoice ? (
              <Tooltip title="Această grilă poate avea mai multe răspunsuri corecte">
                <div>
                  <BiSelectMultiple className="w-[30px] !text-over-primary-background h-[30px]" />
                </div>
              </Tooltip>
            ) : null} */}

            {!createGrid ? (
              <div>
                {!(started === false || endTrial) ? (
                  <Tooltip
                    title={!isSubject ? 'Setări grile' : 'Lista grilelor'}
                  >
                    <div>
                      {!isSubject ? (
                        <LuSettings2
                          onClick={() => {
                            handleUnFocusTour()
                            setFilterSettings(true)
                          }}
                          className="w-[23px] grid-filter cursor-pointer h-[23px] text-over-secondary-background"
                        />
                      ) : isMobile ? (
                        <LuListTodo
                          className="text-over-secondary-background cursor-pointer"
                          onClick={handleGridsSidebar}
                        />
                      ) : null}
                    </div>
                  </Tooltip>
                ) : null}
              </div>
            ) : null}
            {!createGrid && !isCreateSubject && isSubmitted && !isSubmitting ? (
              <Tooltip title="Salvează grila">
                <FontAwesomeIcon
                  id="save-grid-btn"
                  onClick={() => {
                    if (isGridSaved) {
                      handleRemoveSavedGrid()
                    } else {
                      if (!userDetails?.tutorial) {
                        handleUnFocusTour()
                      }
                      handleOpenNoteModal()
                    }
                  }}
                  className={`hint-icon cursor-pointer w-[25px] h-[25px] ${
                    !isGridSaved ? 'text-gray-500' : 'text-secondary'
                  }`}
                  icon={faStar}
                />
              </Tooltip>
            ) : null}
          </>
        )}
      </div>
    </div>
  )
}

export default Header
